export const gateway = '//192.168.177.180:19010/v1/'